import { Link } from 'react-router-dom';
import { Navbar } from '../home/components/Navbar';
import { Footer } from '../home/components/Footer';

const placeholderLabels = [
  'Coming Soon',
  'Design in Progress',
  'Future Bulldogs Tee',
  'Coming Soon',
  'Design in Progress',
  'Future Bulldogs Tee',
];

const placeholderColors = [
  ['#6B0000', '#FFFFFF', '#808080'],
  ['#F5F5DC', '#6B0000', '#111827'],
  ['#808080', '#FFFFFF', '#6B0000'],
  ['#FFFFFF', '#6B0000', '#808080'],
  ['#6B0000', '#111827', '#FFFFFF'],
  ['#FFFFFF', '#808080', '#6B0000'],
];

const placeholderImages = [
  'https://public.readdy.ai/ai/img_res/7a6f9c70b49a7d85d4f6b27a705e5490.jpg',
  'https://readdy.ai/api/search-image?query=plain%20white%20t-shirt%20mockup%20ghost%20mannequin%20on%20pure%20white%20background%2C%20clean%20minimal%20product%20photography%2C%20soft%20studio%20lighting%2C%20cotton%20fabric%20texture&width=600&height=750&seq=ph_bs_02&orientation=portrait',
  'https://readdy.ai/api/search-image?query=plain%20gray%20t-shirt%20mockup%20ghost%20mannequin%20on%20pure%20white%20background%2C%20clean%20minimal%20product%20photography%2C%20soft%20studio%20lighting%2C%20cotton%20fabric%20texture&width=600&height=750&seq=ph_bs_03&orientation=portrait',
  'https://readdy.ai/api/search-image?query=plain%20cream%20t-shirt%20mockup%20ghost%20mannequin%20on%20pure%20white%20background%2C%20clean%20minimal%20product%20photography%2C%20soft%20studio%20lighting%2C%20cotton%20fabric%20texture&width=600&height=750&seq=ph_bs_04&orientation=portrait',
  'https://readdy.ai/api/search-image?query=plain%20black%20t-shirt%20mockup%20ghost%20mannequin%20on%20pure%20white%20background%2C%20clean%20minimal%20product%20photography%2C%20soft%20studio%20lighting%2C%20cotton%20fabric%20texture&width=600&height=750&seq=ph_bs_05&orientation=portrait',
  'https://readdy.ai/api/search-image?query=plain%20maroon%20long%20sleeve%20t-shirt%20mockup%20ghost%20mannequin%20on%20pure%20white%20background%2C%20clean%20minimal%20product%20photography%2C%20soft%20studio%20lighting%2C%20cotton%20fabric%20texture&width=600&height=750&seq=ph_bs_06&orientation=portrait',
];

export default function BestSellersPage() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />

      {/* Hero Banner */}
      <section className="relative pt-32 pb-20 px-6 bg-gradient-to-br from-[#6B0000] via-[#8B0000] to-[#6B0000] overflow-hidden">
        <div className="absolute inset-0 opacity-10">
          <div className="absolute top-0 left-0 w-96 h-96 bg-white rounded-full blur-3xl"></div>
          <div className="absolute bottom-0 right-0 w-96 h-96 bg-white rounded-full blur-3xl"></div>
        </div>
        <div className="max-w-7xl mx-auto relative z-10">
          <div className="text-center">
            <span className="inline-block px-4 py-1.5 bg-white/20 backdrop-blur-sm text-white text-xs font-bold uppercase tracking-widest rounded-full mb-6">
              Top Rated Collection
            </span>
            <h1 className="text-5xl md:text-6xl font-black text-white mb-4">
              Fan Favorites
            </h1>
            <p className="text-xl text-white/90 max-w-2xl mx-auto mb-8">
              Our most-loved Bulldogs shirts, ranked by customer reviews and sales. These designs are flying off the press in Starkville.
            </p>
            <div className="flex items-center justify-center gap-8 text-white/90">
              <div className="flex items-center gap-2">
                <div className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-star-fill text-yellow-400"></i>
                </div>
                <span className="text-sm font-semibold">4.9 Average Rating</span>
              </div>
              <div className="flex items-center gap-2">
                <div className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-shopping-bag-3-fill"></i>
                </div>
                <span className="text-sm font-semibold">2,400+ Sold</span>
              </div>
              <div className="flex items-center gap-2">
                <div className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-map-pin-fill"></i>
                </div>
                <span className="text-sm font-semibold">Printed in Starkville</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Coming Soon Notice */}
      <section className="py-8 px-6">
        <div className="max-w-7xl mx-auto">
          <div className="flex items-center gap-4 bg-[#6B0000]/8 border border-[#6B0000]/20 rounded-xl px-6 py-4">
            <div className="w-10 h-10 flex items-center justify-center bg-[#6B0000]/10 rounded-full shrink-0">
              <i className="ri-time-line text-[#6B0000] text-xl"></i>
            </div>
            <div>
              <p className="text-sm font-bold text-[#6B0000]">Best Sellers Coming Soon</p>
              <p className="text-sm text-gray-600">Our top-rated designs are being finalized. Want something now? Design your own custom Bulldogs shirt in our studio!</p>
            </div>
            <Link
              to="/customize"
              className="ml-auto px-5 py-2.5 bg-[#6B0000] text-white text-sm font-bold rounded-lg hover:bg-[#550000] transition-colors whitespace-nowrap cursor-pointer"
            >
              Design Your Shirt
            </Link>
          </div>
        </div>
      </section>

      {/* Placeholder Product Grid */}
      <section className="py-8 px-6">
        <div className="max-w-7xl mx-auto">
          <div className="flex items-center justify-between mb-10">
            <div>
              <h2 className="text-3xl font-black text-gray-900 mb-2">Top 6 Best Sellers</h2>
              <p className="text-gray-500 text-sm">Designs will be revealed soon — stay tuned!</p>
            </div>
            <Link
              to="/shop"
              className="inline-flex items-center gap-2 px-5 py-2.5 bg-gray-900 text-white text-sm font-bold rounded-lg hover:bg-[#6B0000] transition-colors whitespace-nowrap"
            >
              View All Products
              <div className="w-4 h-4 flex items-center justify-center">
                <i className="ri-arrow-right-line"></i>
              </div>
            </Link>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-product-shop>
            {placeholderLabels.map((label, index) => (
              <PlaceholderCard
                key={index}
                rank={index + 1}
                label={label}
                image={placeholderImages[index]}
                colors={placeholderColors[index]}
              />
            ))}
          </div>
        </div>
      </section>

      {/* Why These Are Best Sellers */}
      <section className="py-20 px-6 bg-gray-50">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-black text-gray-900 mb-4">
              Why Customers Love These Designs
            </h2>
            <p className="text-lg text-gray-600 max-w-2xl mx-auto">
              These shirts have earned their spot as fan favorites through quality, style, and authentic Bulldogs pride.
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            {[
              { icon: 'ri-star-fill', title: 'Top Rated', desc: 'Average 4.9★ rating from verified customers' },
              { icon: 'ri-printer-fill', title: 'Premium Quality', desc: 'High-quality prints that last wash after wash' },
              { icon: 'ri-map-pin-fill', title: 'Local Pride', desc: 'Designed and printed right here in Starkville' },
              { icon: 'ri-flashlight-fill', title: 'Fast Turnaround', desc: 'Most orders ship within 48 hours' },
            ].map((item) => (
              <div key={item.title} className="bg-white rounded-xl p-6 text-center shadow-sm hover:shadow-md transition-shadow">
                <div className="w-14 h-14 bg-red-50 rounded-full flex items-center justify-center mx-auto mb-4">
                  <div className="w-7 h-7 flex items-center justify-center">
                    <i className={`${item.icon} text-[#6B0000] text-2xl`}></i>
                  </div>
                </div>
                <h3 className="text-lg font-bold text-gray-900 mb-2">{item.title}</h3>
                <p className="text-sm text-gray-600">{item.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 px-6 bg-gradient-to-br from-[#6B0000] to-[#8B0000]">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-4xl md:text-5xl font-black text-white mb-6">
            Design Your Own Bulldogs Shirt
          </h2>
          <p className="text-xl text-white/90 mb-8">
            Can&apos;t find exactly what you&apos;re looking for? Create a custom design in our studio and we&apos;ll print it locally in Starkville.
          </p>
          <Link
            to="/customize"
            className="inline-flex items-center gap-2 px-8 py-4 bg-white text-[#6B0000] text-lg font-bold rounded-xl hover:bg-gray-100 transition-colors whitespace-nowrap shadow-xl"
          >
            <div className="w-5 h-5 flex items-center justify-center">
              <i className="ri-brush-fill"></i>
            </div>
            Start Designing
          </Link>
        </div>
      </section>

      <Footer />
    </div>
  );
}

function PlaceholderCard({
  rank,
  label,
  image,
  colors,
}: {
  rank: number;
  label: string;
  image: string;
  colors: string[];
}) {
  return (
    <div className="relative bg-white rounded-2xl shadow-md overflow-hidden border border-gray-100 opacity-60 select-none">
      {/* Rank Badge */}
      <div className="absolute top-4 left-4 z-20">
        <div className="w-12 h-12 bg-gradient-to-br from-yellow-400 to-yellow-600 rounded-full flex items-center justify-center shadow-lg border-2 border-white">
          <span className="text-white text-lg font-black">#{rank}</span>
        </div>
      </div>

      {/* Product Image */}
      <div className="relative h-80 overflow-hidden bg-gray-50">
        <img
          src={image}
          alt="Coming soon"
          className="w-full h-full object-contain blur-[2px] scale-105"
        />
        {/* Overlay */}
        <div className="absolute inset-0 bg-white/40 flex flex-col items-center justify-center gap-2">
          <div className="w-10 h-10 flex items-center justify-center bg-white/80 rounded-full shadow">
            <i className="ri-lock-line text-[#6B0000] text-lg"></i>
          </div>
          <span className="px-4 py-1.5 bg-[#6B0000] text-white text-xs font-bold rounded-full shadow-md tracking-wide">
            {label}
          </span>
        </div>
      </div>

      {/* Info Skeleton */}
      <div className="p-6">
        <div className="h-4 bg-gray-200 rounded-full w-3/4 mb-4"></div>
        <div className="flex items-center gap-1 mb-4">
          {[...Array(5)].map((_, i) => (
            <div key={i} className="w-4 h-4 bg-gray-200 rounded-full"></div>
          ))}
          <div className="h-3 bg-gray-200 rounded-full w-16 ml-2"></div>
        </div>
        <div className="flex items-center gap-2 mb-5">
          {colors.map((color, i) => (
            <div
              key={i}
              className="w-6 h-6 rounded-full border-2 border-gray-300"
              style={{ backgroundColor: color }}
            ></div>
          ))}
        </div>
        <div className="flex items-center justify-between pt-4 border-t border-gray-100">
          <div className="h-6 bg-gray-200 rounded-full w-16"></div>
          <div className="w-24 h-9 bg-gray-200 rounded-lg"></div>
        </div>
      </div>
    </div>
  );
}
